import { authHttp } from '../http'
import { urlPostSimularRoteirizacaoAutomatica } from '../../routes/deliveries.routes'
import { errorHandler } from '../../../util/error.service'

export async function simularRoteirizacaoAutomatica(payload) {
  try {
    const response = await authHttp().post(urlPostSimularRoteirizacaoAutomatica(), payload)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
